import styled, { css } from "styled-components";
import {
  GrayColors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";

export const StyledChecklistSection = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background: ${GrayColors["G-0-5"]};
  padding: 10px;
`;

export const StyledTaskControllers = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .trash-icon {
    opacity: 0.4;
    margin-right: 10px;
    margin-bottom: 5px;

    transition: opacity 250ms ease-in-out;

    &:hover {
      opacity: 1;
    }
  }
  .drag-icon {
    margin-right: 10px;
    margin-top: 5px;
  }
`;

export const StyledDragIcon = styled.div`
  visibility: hidden;

  color: ${TextColorNames.secondary};

  &:hover {
    color: ${SolutionColorVariables.sc3};
  }
`;
export const StyledTrashIcon = styled.div`
  visibility: hidden;
`;

export const StyledTaskSection = styled.div<{ isDragInProgress: boolean }>`
  display: flex;
  margin-bottom: 10px;

  ${({ isDragInProgress }) =>
    isDragInProgress
      ? css`
          ${StyledDragIcon} {
            visibility: visible;
          }
        `
      : ""}

  &:hover {
    ${StyledDragIcon} {
      visibility: visible;
    }

    ${({ isDragInProgress }) =>
      isDragInProgress
        ? ""
        : css`
            ${StyledTrashIcon} {
              visibility: visible;
            }
          `}
  }
`;

export const StyledHr = styled.hr`
  border: none;
  width: 100%;
  border-top: 1px solid ${GrayColors["G-1-5"]};
`;

export const StyledButtonWrapper = styled.div`
  margin-left: 25px;
`;
